const remote = {
    base: 'http://slearn-service.sharedlearning.in/api',
    authKey: 'webAuthTemp101'
}

export default remote;